import React, { useMemo } from "react";
import { Space } from "antd";
import StandardTable from "../../StandardTable/StandardTable";
import { fetchSearchRes } from "../../../api/services";
import styles from "./index.module.less";
import { FormattedMessage } from "react-intl";

const SearchResult = ({ type, value }) => {
  const columns = useMemo(
    () => [
      {
        title: <FormattedMessage id="name" />,
        dataIndex: "name",
        width: "25%",
        onCell: () => ({
          colSpan: 4,
        }),
      },
      {
        title: <FormattedMessage id="type" />,
        width: "25%",
      },
      {
        title: <FormattedMessage id="date" />,
        width: "25%",
      },
      {
        title: <FormattedMessage id="file" />,
        width: "25%",
      },
    ],
    [],
  );

  const category = useMemo(() => {
    switch (type) {
      case "firmware":
        return "firmware";
      case "documents":
        return "Specifications,Manuals,DeveloperDocumentation,StructuralDrawings,Flyers";
      case "DeveloperTools":
        return "DeveloperTools,apps,dockers";
      default:
        return undefined;
    }
  }, [type]);

  const tableProps = useMemo(() => {
    const commonParams = {
      name: value,
      category,
    };
    return {
      key: `table-${type}`,
      request: fetchSearchRes,
      params: commonParams,
      expandable: type,
    };
  }, [value, type, category]);

  return (
    <div className={styles.container}>
      <Space className={styles.customTableHeader}>
        {columns.map((v, index) => (
          <div
            key={`header-row-${index}`}
            className={styles.headerItem}
          >
            {v.title}
          </div>
        ))}
      </Space>
      <div className={styles.tableContainer}>
        <StandardTable {...tableProps} />
      </div>
    </div>
  );
};

export default SearchResult;
